import {
  Component,
  OnInit,
  AfterViewInit,
  ViewChild,
  ElementRef
} from "@angular/core";
import PublicExposureData from "src/assets/public-exposure-data.json";

@Component({
  selector: "app-vic-details-map",
  templateUrl: "./vic-details-map.component.html",
  styleUrls: ["./vic-details-map.component.scss"]
})
export class VicDetailsMapComponent implements OnInit, AfterViewInit {
  @ViewChild("mapContainer") gmap: ElementRef;
  map: google.maps.Map;
  lat = -37.811973;
  lng = 144.9599133;
  markers: VicDetailsMapDataType[];
  previousInfoWindow: google.maps.InfoWindow;

  mapOptions: google.maps.MapOptions = {
    center: new google.maps.LatLng(this.lat, this.lng),
    zoom: 8.5
  };

  ngOnInit() {
    this.configureMarkers();
  }

  ngAfterViewInit(): void {
    this.mapInitializer();
  }

  private configureMarkers(): void {
    const result: any[] = [];
    const vicDetailsMapData: any[] = RAW_DATA.filter(item => {
      return item.locationType !== "flight" && item.lat && item.lng;
    });

    const group = vicDetailsMapData.reduce((acc, item) => {
      if (!acc[item.lat + item.lng]) {
        acc[item.lat + item.lng] = [];
      }

      acc[item.lat + item.lng].push(item);
      return acc;
    }, {});

    Object.values(group).forEach((arr: any) => {
      const firstItem = arr[0];
      const tempDict: any = {};
      tempDict["position"] = new google.maps.LatLng(
        parseFloat(firstItem.lat),
        parseFloat(firstItem.lng)
      );
      tempDict["map"] = this.map;

      if (arr.length === 1) {
        tempDict["title"] = this.buildSingleTitle(firstItem);
      } else {
        tempDict["title"] = arr.reduce(
          (a, b) => this.buildSingleTitle(a) + "<hr>" + this.buildSingleTitle(b)
        );
      }
      result.push(tempDict);
    });

    this.markers = result;
  }

  private buildSingleTitle(item: any): string {
    let info = "";

    if (item.caseNumber) {
      info += `<br/><b>Case No. in VIC: </b>${item.caseNumber}`;
    }

    if (item.dateConfirmed) {
      info += `<br/><b>Date Confirmed: </b>${item.dateConfirmed}`;
    }

    if (item.age) {
      info += `<br/><b>Age: </b>${item.age}`;
    }

    if (item.gender) {
      info += `<br/><b>Gender: </b>${item.gender}`;
    }

    if (item.description) {
      let descriptionList = "";
      item.description.forEach(d => {
        descriptionList += `<li>${d}</li>`;
      });
      info += `<br/><b>Description: </b><ol>${descriptionList}</ol>`;
    }

    if (item.location) {
      info += `<br/><b>Location: </b>${item.location}`;
    }

    if (item.dateAndTime) {
      info += `<br/><b>Time Visited here: </b>${item.dateAndTime}`;
    }

    if (item.onsetOfSymptomsUpTo) {
      info += `<br/><b>Onset of Symptoms up to: </b>${item.onsetOfSymptomsUpTo}`;
    }

    if (item.sourceLink) {
      item.sourceLink.forEach((link, index) => {
        info += `<br/><b>Source: </b><a href="${link}" target="_blank">Link ${index +
          1}</a>`;
      });
    }

    return info;
  }

  private mapInitializer(): void {
    this.map = new google.maps.Map(this.gmap.nativeElement, this.mapOptions);

    this.loadAllMarkers();

    this.removeTooltip();
  }

  private loadAllMarkers(): void {
    this.markers.forEach((markerInfo: any) => {
      const marker = new google.maps.Marker({
        ...markerInfo
      });

      const infoWindow = new google.maps.InfoWindow({
        content: marker.getTitle()
      });

      marker.addListener("click", () => {
        infoWindow.open(marker.getMap(), marker);
        if (this.previousInfoWindow) {
          this.previousInfoWindow.close();
        }
        this.previousInfoWindow = infoWindow;
      });

      marker.addListener("mouseover", (e: Event) => {
        infoWindow.open(marker.getMap(), marker);
        if (this.previousInfoWindow) {
          this.previousInfoWindow.close();
        }
        this.previousInfoWindow = infoWindow;
      });

      marker.setMap(this.map);
    });
  }

  private removeTooltip() {
    setTimeout(() => {
      (document.querySelectorAll('[log="miw"]') as NodeListOf<
        HTMLElement
      >).forEach(ele => (ele.title = ""));
    }, 4000);
  }
}

export interface VicDetailsMapDataType {
  caseNumber?: string;
  dateConfirmed?: string;
  description?: string[];
  lat: string;
  lng: string;
  sourceLink?: string[];
  location?: string;
  age?: string;
  gender?: string;
  dateAndTime?: string;
  onsetOfSymptomsUpTo?: string;
  locationType: string;
}

const RAW_DATA = PublicExposureData;
